import { render, staticRenderFns } from "./FormTableOpname.vue?vue&type=template&id=89d1c42c&"
import script from "./FormTableOpname.vue?vue&type=script&lang=ts&"
export * from "./FormTableOpname.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89d1c42c')) {
      api.createRecord('89d1c42c', component.options)
    } else {
      api.reload('89d1c42c', component.options)
    }
    module.hot.accept("./FormTableOpname.vue?vue&type=template&id=89d1c42c&", function () {
      api.rerender('89d1c42c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StockAdjustment/FormTableOpname.vue"
export default component.exports